import React from "react";

/**
 * Context containing a list of feature flips an editor has access to. Example:
 *
 * ```js
 * {
 *   manageUser: false,
 *   ipAddressFilter: true,
 * }
 * ```
 *
 * This context value is an empty JSON by default.
 */
const FeatureFlipsContext = React.createContext({});

export default FeatureFlipsContext;
